import React from "react";
import { Loader } from "../../assets/svgs";
import "./pageLoader.css";

export const PageLoader = () => {
	return (
		<div className="page_loader_container">
			<div className="loader" />
			<Loader className="top" />
		</div>
	);
};
